import {charcoal} from '../sass/base/_exports.sass';

export const ReflectHorizontalIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      style={style}
      fill="none"
    >
      <path
        d="M3.5 18.125L9.5 12.125L3.5 6.125V18.125ZM15.5 12.125L21.5 18.125V6.125L15.5 12.125ZM11.5 3.125H13.5V6.125H11.5V3.125ZM11.5 8.125H13.5V11.125H11.5V8.125ZM11.5 13.125H13.5V16.125H11.5V13.125ZM11.5 18.125H13.5V21.125H11.5V18.125Z"
        fill={color}
      />
    </svg>
  );
};
